import { CustomMainContent } from "../../components";
import { useState } from "react";
import { HelpButtons } from "./templates/HelpButtonsLearning";
import { PrincipalHeader } from "./templates/PrincipalHeader";
import { MainTableUiVersionTwo } from "./templates/VersionUITwo/MainTableUiVersionTwo";

// const options = [
//     { key: 1, value: "General" },
//     { key: 2, value: "Capacitacion1" },
//     { key: 3, value: "Capacitacion2" },
//     { key: 4, value: "Capacitacion3" },
//     { key: 5, value: "Capacitacion4" },
// ];

const LearningTable = () => {
    const [hasFilter, setHasFilter] = useState(false);
    const [dateRange, setDataRange] = useState(null);

    return (
        <CustomMainContent>
            <div className="flex h-full w-full min-w-[800px] ">
                <div className="w-100-68  h-full flex flex-col gap-4 ">
                    <div className="w-full h-14 shadow-md bg-white rounded-t-xl rounded-b-[4px]">
                        <PrincipalHeader
                            hasFilter={hasFilter}
                            setFilter={(value) => setHasFilter(value)}
                            dateRange={dateRange}
                            setDataRange={setDataRange}
                        />
                    </div>
                    {/* <div className="w-full h-100-56   bg-white rounded-xl z-20 shadow-md ">
                        <MainContent dateRange={dateRange} hasFilter={hasFilter} />
                    </div> */}
                    <div className="w-full h-100-56 bg-white rounded-t-[4px] rounded-b-xl z-20 shadow-md ">
                        <MainTableUiVersionTwo dateRange={dateRange} hasFilter={hasFilter}></MainTableUiVersionTwo>
                    </div>
                </div>
                <div className="w-[68px] h-full flex justify-center">
                    <HelpButtons />
                </div>
            </div>
        </CustomMainContent>
    );
};

export default LearningTable;
